import { render, staticRenderFns } from "./RequisitionDetailDrawer.vue?vue&type=template&id=5a6d90bd&"
import script from "./RequisitionDetailDrawer.vue?vue&type=script&lang=ts&"
export * from "./RequisitionDetailDrawer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports